import React, { useMemo, useContext } from 'react';

import UserContext from 'contexts/UserContext';
import Modal from 'components/Modal';

import Blank from 'containers/Administrator/Users/Create_Old/Student/Blanks/Blank';

const Blanks = ({ gradeId, modal, handleModal }) => {
	// Use user's context
	const { user } = useContext(UserContext);

	// Store blanks
	const blanks = useMemo(() =>
		user.grades.find(grade => grade.id === gradeId)?.blanks
	, [user.grades, gradeId]);

	return (
		<Modal title="Izvēlieties sagatavi" visible={modal} handleModal={handleModal}>
			<div className="studentCourses studentCourses--modal withMarginTop">
				{blanks.map(blank =>
					<Blank
						key={blank.id}
						gradeId={gradeId}
						blank={blank}
						handleModal={handleModal}
					/>
				)}
			</div>
		</Modal>
	);
};

export default Blanks;